/**
 * Filterable diagnostics for Fetch News (RSS + Mercury).
 * - Search console: [SneakerCrush][RSS]
 * - If logs seem empty on live: DevTools → Console → ensure "Info" / "Verbose" levels are on, or type: __SNEAKER_CRUSH_RSS_DIAG__
 */

export function rssDiagContext() {
  try {
    return {
      nodeEnv: typeof process !== 'undefined' && process.env && process.env.NODE_ENV,
      origin:
        typeof window !== 'undefined' && window.location && window.location.origin
          ? window.location.origin
          : undefined,
    };
  } catch (_) {
    return {};
  }
}

export function rssDiag(level, event, data) {
  const line = { ...rssDiagContext(), ...data };
  const msg = `[SneakerCrush][RSS] ${event}`;
  try {
    if (typeof window !== 'undefined') {
      window.__SNEAKER_CRUSH_RSS_DIAG__ = { t: Date.now(), level, event, ...line };
    }
  } catch (_) {}
  if (level === 'error') {
    console.error(msg, line);
  } else if (level === 'warn') {
    console.warn(msg, line);
  } else {
    // console.info is hidden when DevTools "Info" level is disabled; log is visible by default.
    console.log(msg, line);
  }
}

/** Axios / browser network errors — safe to log (no auth headers). */
export function serializeAxiosError(err) {
  if (!err) return { message: 'unknown error' };
  const out = {
    name: err.name,
    message: err.message,
    code: err.code,
  };
  if (err.response) {
    out.httpStatus = err.response.status;
    out.httpStatusText = err.response.statusText;
    const d = err.response.data;
    if (typeof d === 'string') {
      out.bodyPreview = d.slice(0, 400);
    } else if (d != null && typeof d === 'object') {
      try {
        out.bodyPreview = JSON.stringify(d).slice(0, 400);
      } catch (_) {
        out.bodyPreview = String(d).slice(0, 400);
      }
    }
    if (out.httpStatus === 404) {
      out.hint =
        'RSS proxy URL may be wrong, or nginx is not forwarding to server/rss-proxy.js (see server/rss-proxy.js).';
    }
    if (out.httpStatus === 403) {
      out.hint = 'Upstream or CDN blocked the request (try from Cloud Function / different UA).';
    }
  } else if (err.message === 'Network Error' || err.code === 'ERR_NETWORK') {
    out.hint =
      'No HTTP response (often CORS preflight failure, offline, or blocked). Compare with Network tab.';
  }
  return out;
}

export function summarizeRemoteProxyPrefix(prefix) {
  if (!prefix || typeof prefix !== 'string') return '(none)';
  try {
    const u = new URL(prefix.replace(/\?url=?$/, '?url='));
    return `${u.origin}${u.pathname}`;
  } catch (_) {
    return prefix.length > 80 ? `${prefix.slice(0, 80)}…` : prefix;
  }
}
